// eslint-disable-next-line import/prefer-default-export
export enum PLAN_STATE_DOCUMENTS {
	PLAN_STATE_DOCUMENTS_LOAD_START = 'PLAN_STATE_DOCUMENTS_LOAD_START',
	PLAN_STATE_DOCUMENTS_LOAD_DONE = 'PLAN_STATE_DOCUMENTS_LOAD_DONE',
	PLAN_STATE_DOCUMENTS_LOAD_FAIL = 'PLAN_STATE_DOCUMENTS_LOAD_FAIL'
}
